import { useEffect, useState } from 'react';
import { apiClient } from '../api/client';
import type { HealthResponse } from '@posternauts/shared';
import { PageContainer } from '../components/PageContainer';

type State =
  | { phase: 'loading' }
  | { phase: 'ok'; data: HealthResponse }
  | { phase: 'error'; message: string };

export function StatusPage() {
  const [state, setState] = useState<State>({ phase: 'loading' });

  useEffect(() => {
    void (async () => {
      const result = await apiClient.health();
      if (result.ok) {
        setState({ phase: 'ok', data: result.data });
      } else {
        setState({ phase: 'error', message: result.error });
      }
    })();
  }, []);

  return (
    <PageContainer>
    <div style={{ maxWidth: '480px' }}>
      <h1 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '20px', color: '#e8e8f0' }}>
        System Status
      </h1>

      {state.phase === 'loading' && (
        <Row label="API" value="Checking…" color="#888" />
      )}

      {state.phase === 'ok' && (
        <>
          <Row label="API"       value="Online"                            color="#4ade80" />
          <Row label="Database"  value="Connected"                         color="#4ade80" />
          <Row label="Version"   value={state.data.version}                color="#e8e8f0" />
          <Row label="Timestamp" value={new Date(state.data.timestamp).toLocaleString()} color="#888" />
        </>
      )}

      {state.phase === 'error' && (
        <Row label="API" value={`Error — ${state.message}`} color="#f87171" />
      )}
    </div>
    </PageContainer>
  );
}

function Row({ label, value, color }: { label: string; value: string; color: string }) {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      padding: '10px 14px',
      marginBottom: '6px',
      background: '#111118',
      borderRadius: '8px',
      border: '1px solid #222230',
      fontSize: '13px',
    }}>
      <span style={{ color: '#888' }}>{label}</span>
      <span style={{ color, fontWeight: 500 }}>{value}</span>
    </div>
  );
}
